export default {
  name: 'LOGIN_SUCCESS',
  fields: {
    category: 'Login Form',
    action: 'Login Sucess',
    label: '',
    value: 0,
    nonInteraction: false
  }
}



// WEBPACK FOOTER //
// ./src/analytics/Events/LoginSuccess.js